//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA SALVAR EMPRESA ---------------//
// Responsável por salvar a empresa criada via API
export default async function disableProductService(id) {
  try {
    await api.patch(`/produtos/${id}/inativar`);
    toast.success("Produto inativado com sucesso");
    return true;
  } catch (error) {
    toast.error("Erro ao inativar produto");
    return false;
  }
}